module.exports = __webpack_public_path__ + "img/gsjersey.1301f4a5.svg";